import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const ITEMS = [
  "Camping 4 étoiles",
  "150 emplacements",
  "Piscine couverte & chauffée",
  "Mini-ferme",
  "Lac de Bannac",
  "Restaurant La Table de Bannac",
  "Nature & détente",
];

export default function MarqueeStrip() {
  return (
    <div className="relative -rotate-1 -mx-4 my-2 z-10" data-testid="marquee">
      <Marquee speed={28} gradient={false} className="bg-pine text-cream py-4 shadow-lg shadow-pine/20">
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center gap-6 mx-6">
            <span className="font-display italic text-lg tracking-wide">{item}</span>
            <Star size={13} className="fill-gold text-gold" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
